<template>
  <div class="app-change-payment-view-wrapper">
    <b-row class="payment-type">
      <b-col cols="12" md="">
        <label><slot name="lblPaymentType">Deine aktuelle Zahlungsart</slot></label>
      </b-col>
      <b-col cols="12" md="">
        <div class="payment-type-value">
          <div class="no-payment" v-if="isNoPayment">
            <slot name="txtNoPayment">Keine Zahlart hinterlegt</slot>
          </div>
          <div v-if="isCreditCard">
            <slot name="txtCreditCard">Kreditkarte</slot>
          </div>
          <div v-if="isBankAccount">
            <slot name="txtBankAccount">Lastschrift</slot>
          </div>
        </div></b-col>
    </b-row>
    <PaymentInformation
      v-if="isBankAccount || isCreditCard"
      :payment="paymentInformation.paymentType">
      <template #txtBefore><slot name="txtBeforePayment"></slot></template>
      <template #txtBeforeCreditCard><slot name="txtBeforeCreditCardPayment"></slot></template>
      <template #lblCcHolderCreditCard><slot name="lblCcHolderCreditCardPayment"></slot></template>
      <template #lblCcNumberCreditCard><slot name="lblCcNumberCreditCardPayment"></slot></template>
      <template #lblCcTypeCreditCard><slot name="lblCcTypeCreditCardPayment"></slot></template>
      <template #lblCcValidtyCreditCard><slot name="lblCcValidtyCreditCardPayment"></slot></template>
      <template #txtAfterCreditCard><slot name="txtAfterCreditCardPayment"></slot></template>
      <template #txtErrorCreditCard><slot name="txtErrorCreditCardPayment"></slot></template>
      <template #txtBeforeBankAccount><slot name="txtBeforeBankAccountPayment"></slot></template>
      <template #lblOwnerBankAccount><slot name="lblOwnerBankAccountPayment"></slot></template>
      <template #lblIbanBankAccount><slot name="lblIbanBankAccountPayment"></slot></template>
      <template #txtAfterBankAccount><slot name="txtAfterBankAccountPayment"></slot></template>
      <template #txtAfter><slot name="txtAfterPayment"></slot></template>
    </PaymentInformation>
    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import processSteps from '@/mixins/processSteps'
import PaymentInformation from './PaymentInformation.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { BRow, BCol } from 'bootstrap-vue'

export const stepName = 'viewPayment'

export default {
  name: 'ShowPaymentData',
  data () {
    return {
      paymentInformation: {
        paymentType: null
      }
    }
  },
  mixins: [
    processSteps(stepName, stepName)
  ],
  components: {
    PaymentInformation, BRow, BCol
  },
  computed: {
    isNoPayment () {
      return this.paymentInformation.paymentType === null
    },
    isCreditCard () {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'creditCard'
      }
      return false
    },
    isBankAccount () {
      if (this.paymentInformation.paymentType !== null) {
        return this.paymentInformation.paymentType.type === 'bankAccount'
      }
      return false
    }
  },
  apollo: {
    paymentInformation: function () {
      return wrapQuery(
        gql`query changePayment {
          paymentInformation {
            paymentType {
            ...on BankAccount {
                type
                iban
                owner
              }
              ...on CreditCard {
                type
                holder
                company
                expiryMonth
                expiryYear
                lastDigits
              }
           }
          }
        }`, this, 'paymentInformation'
      )
    }
  }
}
</script>
